<script setup lang="ts">
import { Toaster } from 'vue-sonner';
</script>

<template>
  <RouterView />

  <!-- Mounted once at the root so a toast survives the route change that a
       merge or a sign-out triggers. Rendered inside the app rather than
       teleported to body so it inherits the theme tokens. -->
  <Toaster position="bottom-right" rich-colors close-button />
</template>
